import React, { useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import RenderField from "./RenderField";
function RenderSection({ section, isAdmin ,isPreview}) {
  const [openSection, setopenSection] = useState(section.isExpanded);
  let column =
    section.columnIndex == 0
      ? "first-col"
      : section.columnIndex == 1
      ? "second-col"
      : "third-col";
  return (
    <div
      className={"d-flex flex-column " + column}
      style={{ marginLeft: "1.5em" }}
    >
      <h6
        className="main-content__title"
        onClick={() => setopenSection(!openSection)}
        style={{
          cursor: "pointer",
          borderBottom: "1px solid black",
          margin: "0",
        }}
      >
        {section.name}
        <IoIosArrowUp
          size={20}
          className={openSection ? "rotate-icon rotated" : "rotate-icon"}
        />
      </h6>
      <div className={openSection ? "" : "hide-row"} style={{ width: "100%" }}>
        {section.sectionFields &&
          section.sectionFields
          .sort((a,b)=>{
            if (a.field.rank !== b.field.rank) {
              return a.field.rank - b.field.rank; // Ascending order for rank
            }
            const aDate = new Date(a.field.created);
            const bDate = new Date(b.field.created);
            return aDate - bDate;
          })
            .map((sectionField) => {
              return !sectionField.field.isDisabled ? (
                <RenderField
                  isPreview = {isPreview}
                  sectionField={sectionField}
                  key = {sectionField.field.fieldId}
                  data={""}
                  isAdmin={isAdmin}
                />
              ) : null;
            })}
      </div>
    </div>
  );
}

export default RenderSection;
